// extracted by mini-css-extract-plugin
module.exports = {"blueSection":"hero_blueSection__W3S0-","buttonDemo":"hero_buttonDemo__2VzgO","despachoImg":"hero_despachoImg__DG6bS","orangeElement":"hero_orangeElement__2zhsQ"};